
import ScrollTo from '@scripts/utilities/scroll-to.js';


(function(window, jQuery) {
  var $window = jQuery(window);

  var currentUrl = window.location.href;
  if (currentUrl.indexOf('#') > 0) {
    currentUrl = currentUrl.substring(0, currentUrl.indexOf('#'));
  }

  var SmoothScroll = function(element) {
    this.element = element;

    this.scrollElement = undefined;

    this.scroll = this.scroll.bind(this);
  }
  SmoothScroll.prototype.initialise = function() {
    // if the url fragment is on the current page, smooth scroll to it.
    var url = this.element.href;
    if (url.indexOf(currentUrl + '#') === 0) {
        if (this.element.hash) {
          this.scrollElement = jQuery(this.element.hash);
        } else {
          // if the link is just "#", then we want to scroll to the top of the
          // page.
          this.scrollElement = jQuery(document.body);
        }

      if (this.scrollElement && this.scrollElement.length) {
        this.element.addEventListener('click', this.scroll);
      }
    }
  };
  SmoothScroll.prototype.scroll = function(event) {
    event.preventDefault();

    ScrollTo(this.scrollElement.offset().top);
  };

  /**
   * implements smooth scrolling for all elements where the anchor is present
   * on the current page.
   */
  $window.on('load', function() {
    var anchors = jQuery('a[href*="#"');

    if (anchors.length) {
      for (var i = 0; i < anchors.length; i++) {
        var anchor = anchors[i];
        if(!anchors[i].hasAttribute('data-toggle')) {
          var tmp = new SmoothScroll(anchors[i]);
          tmp.initialise();
        }
      }
    }
  });
})(window, jQuery);

